module.exports = __webpack_public_path__ + "img/teamLeader.d747300a.svg";